// extracted by mini-css-extract-plugin
module.exports = {"options":"mobileDeckMoreMenu_options__BheR3","header":"mobileDeckMoreMenu_header__P8aXU","prominent":"mobileDeckMoreMenu_prominent__DyoVt"};